import { BaseEntity } from "yt-ng-framework";

export class IzvodStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    RB: number;
    Komitent: string;
    Mesto: string;
    Duguje: number;
    Potrazuje: number;
    OrgJed: string;
    BrojFakture: string;

    Deserialize(input:any){
        this.ID=input.ID;
        this.RB=input.RB;
        this.Komitent=input.Komitent; 
        this.Mesto=input.Mesto; 
        this.Duguje=input.Duguje; 
        this.Potrazuje=input.Potrazuje;      
        this.OrgJed = input.OrgJed;
        this.BrojFakture = input.BrojFakture;
        return this;
    }

    Serialize(input:IzvodStavkaView){
        return input;
    }

}
